/**
 * @author Панова Анастасия(@panova)
 * @copyright Курочкин Денис(@kurochkin)
 */

export default class PlayerYoutube {
  constructor(options) {
    this.options = this._extendOptions(options)
    this.images = Array.from(document.querySelectorAll(this.options.selectorImage))
    this.videoDataList = []
  }

  insertPlayers(sliderContainer) {
    if (!sliderContainer) {
      return
    }

    if (!this.images.length) {
      return
    }

    this._getVideoDataList()

    if (!this.videoDataList.length) {
      return
    }

    this.sliderContainer = sliderContainer
    this.sliderContainer.innerHTML = this._generateSlides()
  }

  /**
   * Обновляет src в айфрейме, вызывается для перезагрузки (остановки) видео
   * @param {Element} iframeNode - Dom узел iframe
   * @param {number} index - индекс, по которому находится нужный id в массиве id видео
   * @public
   */
  updateVideo(iframeNode, index) {
    if (typeof index !== 'number' || index < 0) {
      return
    }

    if (!(iframeNode instanceof Node)) {
      return
    }

    iframeNode.setAttribute('src', this._getPathSrcVideo(this.videoDataList[index]))
  }

  _getPathSrcVideo({ idPlayer, rutubeLink }) {
    return rutubeLink || `https://www.youtube.com/embed/${idPlayer}?autoplay=1&rel=0&showinfo=0`
  }

  _getVideoDataList() {
    this.images.forEach(image => {
      const rutubeLink = image.getAttribute('data-rutube-link')
      const idPlayer = image.getAttribute('data-id-player')

      if (rutubeLink || idPlayer) {
        this.videoDataList.push({
          idPlayer,
          rutubeLink,
        })
      }
    })
  }

  _generateSlides() {
    const template = this.videoDataList.reduce((acc, data) => {
      const iframe = `
                <iframe class="b-video__iframe b-swiper__slide"
                    src="${this._getPathSrcVideo(data)}"
                    frameborder="0"
                    ${this._getAttributes()}
                ></iframe>
            `

      return acc + iframe
    }, '')

    return template
  }

  _getAttributes() {
    return this.options.iframeAttributes.join(',')
  }

  _extendOptions = (options = {}) => {
    const optionsDefault = {
      selectorImage: '.b-video__preview_js',
      iframeAttributes: [],
    }

    return { ...optionsDefault, ...options }
  }
}
